export default {
      id: "oc-res-vpc-peerconnect-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-vpc-peerconnect",
      toString: function () {
        return this.url;
      }
    }